
import Utils from './utils';
import * as keys from './keys';
import isObjectEmpty from 'utils/isObjectEmpty';

const FormObserver = (formRef, props) => {
    formRef.$('PPT').observe({
        key: 'value',
        call: ({ field }) => {
            console.log(field.value.id, "field", formRef.get())
            let PlanOption = formRef.$("plan-option").value.id
            let ppt = field.value.id
            let requestData = {}
            switch (Number(PlanOption)) {
                case 1:
                    let ptlist = []
                    if (Number(ppt) >= 5 && Number(ppt) <= 8) {
                        ptlist = Utils.PredefinedOptList(10, 10, 40);
                    } else if (Number(ppt) >= 9 && Number(ppt) <= 12) {
                        ptlist = Utils.PredefinedOptList(15, 15, 40);
                    }
                    formRef.$("PT").set("extra", {
                        ...formRef.$("PT").extra,
                        isVisible: true,
                        optionList: ptlist
                    })
                    formRef.$("PT").set("value", { id: 20, label: 20 })

                    requestData = {
                        ppt: field.value.id,
                        pt: 20,
                        incomeDuration: "0"
                    }
                    break;

                case 2:

                    let incomeDuration = formRef.$('income-duration')?.value
                    if (!isObjectEmpty(incomeDuration)) {
                        formRef.$('PT').set('value', { label: Number(incomeDuration?.label) + Number(ppt) + 1, id: Number(incomeDuration?.label) + Number(ppt) + 1 })
                    }

                    if (Number(ppt) >= 5 && Number(ppt) <= 7) {
                        formRef.$("income-duration").set("extra", {
                            ...formRef.$("income-duration").extra,
                            isVisible: true,
                            optionList: [
                                { id: 4, label: '15' },
                                { id: 5, label: '20' },
                                { id: 6, label: '25' },
                                { id: 7, label: '30' },
                                { id: 8, label: '35' },
                            ]
                        })
                    } else if (Number(ppt) >= 8 && Number(ppt) <= 12) {
                        formRef.$("income-duration").set("extra", {
                            ...formRef.$("income-duration").extra,
                            isVisible: true,
                            optionList: [
                                { id: 3, label: '10' },
                                { id: 4, label: '15' },
                                { id: 5, label: '20' },
                                { id: 6, label: '25' },
                                { id: 7, label: '30' }
                            ]
                        })
                    }
                    let IncomeBenefitPayoutStartYearlist = Utils.PredefinedOptList(1, 21, Number(field.value.id))
                    formRef.$("income-benefit-payout-start-year").set("extra", {
                      ...formRef.$("income-benefit-payout-start-year").extra,
                      isVisible: true,
                      optionList: IncomeBenefitPayoutStartYearlist
                    })
                    formRef.$("income-duration").set("value", { id: 6, label: '25' })
                    requestData = {
                        ppt: field.value.id,
                        pt: 100,
                        incomeDuration: 6
                    }
                    break;


            }

            Utils.updateBi(keys.PPT, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('PT').observe({
        key: 'value',
        call: ({ field }) => {
            let pptValue = formRef.$("PPT").value.id
            let requestData = {
                pt: field.value.id,
                ppt: pptValue
            }
            Utils.updateBi(keys.PT, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-duration').observe({
        key: 'value',
        call: ({ field }) => {
            let ppt = formRef.$('PPT')?.value
            if (!isObjectEmpty(ppt)) {
                formRef.$('PT').set('value', { label: Number(field?.value?.label) + Number(ppt?.id) + 1, id: Number(field?.value?.label) + Number(ppt?.id) + 1 })
            }
            let requestData = {
                incomeDuration: field.value.id,
                pt: 100
            }
            Utils.updateBi(keys.INCOME_DURATION, requestData, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-option').observe({
        key: 'value',
        call: ({ field }) => {
            let incomeOption = field.value.id
            switch (Number(incomeOption)) {
                case 9:
                    formRef.$("increasing").set("extra", {
                        ...formRef.$("increasing").extra,
                        isVisible: false
                    })
                    break;

                case 10:
                    formRef.$("increasing").set("extra", {
                        ...formRef.$("increasing").extra,
                        isVisible: true
                    })
                    break;
            }
            Utils.updateBi(keys.INCOME_OPTION, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('payment-frequency').observe({
        key: 'value',
        call: ({ field }) => {
            let premium = formRef.$("premium").value;
            let frequency = Number(field.value.id);

            let data = {
                premium: premium,
                frequency: frequency,
            };
            Utils.updateBi(keys.FREQUENCY, data, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-benefit-pay-out-type').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCOME_BENEFIT_PAYOUT_TYPE, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('cashback').observe({
        key: 'value',
        call: ({ field }) => {
            let cashback = field.value.id
            switch (Number(cashback)) {
                case 35:
                    formRef.$("cashback-percentage").set("extra", {
                        ...formRef.$("cashback-percentage").extra,
                        isVisible: true
                    })
                    break;

                case 36:
                    formRef.$("cashback-percentage").set("extra", {
                        ...formRef.$("cashback-percentage").extra,
                        isVisible: false
                    })
                    formRef.$("cashback-percentage").set("value", "")
                    break;

                default:
                    break;
            }
            Utils.updateBi(keys.CASHBACK, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('increasing').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCREASING, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('cashback-percentage').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.CASHBACK_PERCENT_ANNUALISED_PREMIUM, field.value, props.data.package_id, formRef, props)
        }
    })
    formRef.$('timing-of-income-from-income-start-year').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.TIMING_OF_INCOME_STAR_TYEAR, field.value.id, props.data.package_id, formRef, props)
        }
    })
    formRef.$('income-benefit-payout-start-year').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCOME_BENEFIT_PAYOUT_START_YEAR, field.value.id, props.data.package_id, formRef, props)
        }
    })
    formRef.$('sum-assure-multiple').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PR_SAMF, field.value.id, props.data.package_id, formRef, props)
        }
    })



    formRef.$('ADB').observe({
        key: 'value',
        call: ({ field }) => {
            let adbValue = formRef.$('ADB-dropdown').value
            Utils.updateBi(keys.ADB_RIDER, adbValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('ATPDRider').observe({
        key: 'value',
        call: ({ field }) => {
            let atpdValue = formRef.$('ATPDRider-dropdown').value
            Utils.updateBi(keys.ATPD_RIDER, atpdValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('CriticalIllnessRider').observe({
        key: 'value',
        call: ({ field }) => {
            let criticalIllness = formRef.$('CriticalIllnessRider-dropdown').value
            Utils.updateBi(keys.Critical_ILLNESS_RIDER, criticalIllness, props.data.package_id, formRef, props)
        }
    })


    formRef.$('HospitalityCashBenefitRider').observe({
        key: 'value',
        call: ({ field }) => {
            let hospitalityCashBenefit = formRef.$('HospitalityCashBenefitRider-dropdown').value
            Utils.updateBi(keys.HOSPITALITY_CASH_BENEFIT_RIDER, hospitalityCashBenefit, props.data.package_id, formRef, props)
        }
    })

    formRef.$('PayorWaiverBenefitRider-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PWB_RIDER, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('family-income-benefit-option-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            if (formRef.$('family-income-benefit-option').value) {
                Utils.updateBi(keys.FAMILY_BENEFIT_INCOME_OPTION, field.value.id, props.data.package_id, formRef, props)
            }
        }
    })
}

export default FormObserver